const allowed = new Set(['P', 'DIV', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'UL', 'OL', 'LI', 'BLOCKQUOTE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'PRE', 'CODE', 'S', 'STRIKE', 'SPAN']);
export function sanitizeHistoryHtml(html) {
  const parsed = new DOMParser().parseFromString(String(html || ''), 'text/html');
  const result = document.createElement('div');
  function copy(source, target) {
    source.childNodes.forEach(node => {
      if (node.nodeType === 3) target.appendChild(document.createTextNode(node.textContent));
      else if (node.nodeType === 1) {
        if (allowed.has(node.tagName)) {
          const clean = document.createElement(node.tagName.toLowerCase());
          target.appendChild(clean);
          copy(node, clean);
        } else copy(node, target);
      }
    });
  }
  copy(parsed.body, result);
  return result.innerHTML;
}

export function hasUnsupportedHistory(html) {
  const doc = new DOMParser().parseFromString(html || '', 'text/html');
  return Array.from(doc.body.querySelectorAll('*')).some(node =>
    !allowed.has(node.tagName) || node.attributes.length > 0);
}
